export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dialogSendPurchase.vue?vue&type=template&id=0f75000b&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/QuotesTracking/dialogSendPurchase.vue?vue&type=template&id=0f75000b&scoped=true
// module id = 2442
// module chunks = 31